import { render } from "./AccountManagement.vue?vue&type=template&id=5598f96a&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"

import "./AccountManagement.vue?vue&type=style&index=0&id=5598f96a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5598f96a"]])

export default __exports__